

/*
	Source: htdocs/wim/js/core/src/MultimediaNavigation.js
*/
(function($, wimbledonCore) {
/**
     *  Poller Class
     *      Used for setting up repeating AJAX loads. Supports
     *      a variety of options ranging from simple to complex.
     */
    function MultimediaNavigation() {
        var id = 'MultiNavigation';
        var logger = new eventsCore.util.Logger(id);
        var api = new Object();
        var summaryContent;
        var contentContainer;

        /**
         * load saved summary contents
         */
        var loadSummary = function() {
            //$('.video-holder').html('');
            logger.info('loadSummary ');
            $('#summary.video-holder').show();
            $('#detail.video-holder').hide();
            addHandlers();
            scrollToTop();
        };

        /**
         * add hash based html fragment loaded
         */
        var loadHash = function(hash) {
            logger.info('loadHash - ' + hash);

            var page = '/en_GB/interactive/multimedia/' + hash + '.html';
            //for testing
            //page = '/mockups/' + hash + '.html';
            logger.info('loadHash - page:%o hash:%o', page, hash);
            $('#summary.video-holder').hide();

            $('#detail.video-holder').html('');
            $('#detail.video-holder').load(page, function(){
                logger.info('loadHash - container:%o', $(contentContainer).scrollTop());
                scrollToTop();
            });
            $('#detail.video-holder').show();

            $('#subMenuBar').find('a').removeClass('active');
            $('#subMenuBar').find('a[href="/en_GB/interactive/multimedia.html#' + hash + '"]').addClass('active');
        };

        /**
         * handles container used to scroll based on windowSize
         */
        var scrollToTop = function() {
            var container = contentContainer;
            if(windowSize !== undefined && windowSize === 'global') {
                container = 'body';
            }
            $(container).animate({
                scrollTop: 0
            }, 100);
        }

        /**
         * add hash based html fragment loaded
         */
        var addPositionNav = function(url) {
            var parts = url.split('/');
            parts = parts[parts.length - 1].split('.')
            page = parts[0];
            window.location.hash = page;
            return page;
        };

        /**
         * add click handlers for sections
         */
        var addHandlers = function() {
            $('.photoGalHeader  a').click(function(e){

                e.preventDefault();
                var hash = addPositionNav(e.currentTarget.href);
                logger.info('click - e:%o text:%o hash:%o', e, $(this).text(), hash);
                window.location.hash = hash;
                //loadHash(hash);

                window.measureApp('Video Gallery', 'Select Category', $(this).text());
            });
        };

        /**
         *
         */
        api.initContent = function(container) {
            $(document).ready(function(){
                contentContainer = container;
                summaryContent = $('.video-holder').html();
                //logger.info('initContent');
                addHandlers();

                var hash = window.location.hash.replace('#','');
                if (hash !== '') {
                    loadHash(hash);
                }
            });

            $(window).on('hashchange',function() {
                var hash = window.location.hash.replace('#','');
                //logger.info('hashchange hash:%o', hash);

                if (hash !== '') {
                    loadHash(hash);
                }
                else {
                    loadSummary();
                }
            });
        };

        return api;
    };

    wimbledonCore.multimediaNavigation = new MultimediaNavigation();

}(jQuery, window.wimbledonCore));